<header id="pageHeader" class="clearfix">
    <!-- logo -->
    <!-- <div class="logo alignLeft">
        <a routerLink="/">
            <img src="{{ _settings.logo }}" alt="{{ _settings.logo_description }}">
        </a>
    </div> -->
    <!-- headerColRight -->
    <div class="pageHeaderColRight alignRight">
        <!-- pageHeaderActionsList -->
        <ul class="listUnstyled pageHeaderActionsList">
            <!-- dropdownWrap -->
            <li class="dropdownWrap">
<!--                <a href="#"><span class="icon-wrench"><span class="srOnly">spanner</span></span></a>-->
                <!-- dropdown -->
                <div class="dropdown">
                    <ul class="dropdownList listUnstyled">
                        <!--<li>
                            <a routerLink="/level-3/cro/alerts">
                                <span class="dropdownIcn icon-notification"><span class="srOnly">alert</span></span>
                                <span>Alerts</span>
                            </a>
                        </li>
                        <li>
                            <a routerLink="/level-3/cro/zone/index">
                                <span class="dropdownIcn icon-direction-group"><span class="srOnly">alert</span></span>
                                <span>Geofencing</span>
                            </a>
                        </li>-->
                        <!-- <li>
                            <a href="#">
                                <span class="dropdownIcn icon-road"><span class="srOnly">alert</span></span>
                                <span>Routes</span>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <span class="dropdownIcn icon-signal-bold"><span class="srOnly">signal</span></span>
                                <span>Reports</span>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <span class="dropdownIcn icon-ruler2"><span class="srOnly">ruler</span></span>
                                <span>Ruler</span>
                            </a>
                        </li> -->
                        <!-- <li>
                            <a href="#">
                                <span class="dropdownIcn icon-marker-outline"><span class="srOnly">marker</span></span>
                                <span>POI</span>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <span class="dropdownIcn icon-pin-point"><span class="srOnly">point of interest</span></span>
                                <span>Show point</span>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <span class="dropdownIcn icon-home"><span class="srOnly">point of interest</span></span>
                                <span>Show address</span>
                            </a>
                        </li> -->
                        <!--<li>
                            <a href="#">
                                <span class="dropdownIcn icon-right"><span class="srOnly">right</span></span>
                                <span>Send command</span>
                            </a>
                        </li>-->
                    </ul>
                </div>
            </li>
            <!--<li>
                <a routerLink="/level-3/cro/profile"><span class="icon-settings"><span class="srOnly">settings</span></span></a>
            </li>
            <li class="dropdownWrap">
                <a href="#"><span class="icon-user2"><span class="srOnly">person</span></span></a>
                <div class="dropdown dropdownRight">
                    <ul class="dropdownList listUnstyled">
                        <li>
                            <a routerLink="/level-3/cro/zone/index">
                                <span class="dropdownIcn icon-user1"><span class="srOnly">person</span></span>
                                <span>Go To App</span>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <span class="dropdownIcn icon-key"><span class="srOnly">alert</span></span>
                                <span>Log out</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>-->
        </ul>
    </div>
</header>
